import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from '@/router/routerCompat';
import { useApp } from '../contexts/useApp';

export function RouteFallback() {
  const { t } = useTranslation('common');
  return (
    <div className="page">
      <div className="page__content flex items-center justify-center min-h-[200px] text-text-secondary">
        {t('messages.loading')}
      </div>
    </div>
  );
}

export function SuspenseRoute({ children }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}

export function withSuspense(Component, props = {}) {
  return function SuspenseWrapped() {
    return (
      <SuspenseRoute>
        <Component {...props} />
      </SuspenseRoute>
    );
  };
}

export function ProtectedRoute({ children }) {
  const { state } = useApp();
  if (!state.isAuthenticated) {
    return <Navigate to="/" />;
  }
  return children;
}

export function withProtected(Component, props = {}) {
  return function ProtectedWrapped() {
    return (
      <ProtectedRoute>
        <SuspenseRoute>
          <Component {...props} />
        </SuspenseRoute>
      </ProtectedRoute>
    );
  };
}

export function DashboardTanStackGate() {
  const { state } = useApp();
  if (!state.isAuthenticated) {
    return <Navigate to="/auth" />;
  }
  const hasDashboardAccess = ['user', 'artist', 'manager', 'admin'].includes(state.user?.role);
  if (!hasDashboardAccess) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
}

export function ArtistManagerAdminOnly({ children }) {
  const { state } = useApp();
  const role = state.user?.role;
  if (role === 'artist' || role === 'manager' || role === 'admin') {
    return children;
  }
  return <Navigate to="/" replace />;
}
